import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReleaseFlagForm } from "../ReleaseFlagForm";
import useGetReleaseFlag from "./api/useGetReleaseFlag";
import useUpdateReleaseFlag from "./api/useUpdateReleaseFlag";
import { ReleaseFlagFormValues } from "../types";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { handleAlert } from "@utils/helperFunctions";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";

const Edit: React.FC = () => {
  const navigate = useNavigate();
  const { releaseFlagId } = useParams<{ releaseFlagId: string }>();
  const id = releaseFlagId ?? "";
  const { releaseFlag, isLoading } = useGetReleaseFlag(id);
  const { submit, isLoading: isSubmitting } = useUpdateReleaseFlag();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFail, setShowFail] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  if (isLoading || !releaseFlag) return <ScopeStackSpinner />;

  const initialValues: ReleaseFlagFormValues = {
    name: releaseFlag.name,
    key: releaseFlag.key,
    description: releaseFlag.description,
    status: releaseFlag.status,
    betaReleaseDate: releaseFlag.betaReleaseDate,
    generalAvailabilityDate: releaseFlag.generalAvailabilityDate,
  };

  const handleSubmit = (values: ReleaseFlagFormValues) => {
    submit(id, values)
      .then(() => {
        setResponseMessage("Release flag updated");
        setShowSuccess(true);
      })
      .catch((err: any) => {
        const detail =
          err?.data?.errors?.[0]?.detail || "Could not update release flag.";
        setResponseMessage(detail);
        setShowFail(true);
      });
  };

  return (
    <div className="releaseFlagsPage legacyPageBleed">
      <ReleaseFlagForm
        mode="edit"
        title={`Edit ${releaseFlag.name}`}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        onCancel={() => navigate("/admin/release_flags")}
        isSubmitting={isSubmitting}
      />
      {handleAlert(
        showSuccess,
        responseMessage,
        setShowSuccess,
        "success",
        ToastAlert
      )}
      {handleAlert(
        showFail,
        responseMessage,
        setShowFail,
        "warning",
        ToastAlert
      )}
    </div>
  );
};

export default Edit;
